<gb-page-loader [loaded$]="loaded$">
  <div class="projector-templates-grid">
    @for (template of projectorTemplates$ | async; track template.uuid) {
      <div
        class="projector-container-card projector-template-card template-select-card"
        (click)="selectTemplate(template.uuid)"
        [class.selected]="getIsSelected(template.uuid)"
      >
        <div class="projector-template-preview">
          <gb-presenter-canvas
            [responsive]="true"
            [draggable]="false"
            [inPreviewMode]="true"
            [templateList]="true"
            [templateConfig]="template.config"
            [templateBackgroundImageUrl]="getTemplateBackgroundImageUrl(template)"
          ></gb-presenter-canvas>
        </div>

        <div class="projector-container-title">{{ template.name }}</div>
        <div class="projector-template-description gb-two-line-truncate">{{ template.description }}</div>
      </div>
    }
  </div>
</gb-page-loader>
